import { UserClaim } from '@/constants/userClaim';
import type { RouteDefinition } from '../types';
import { RouteName } from '../constants/routeNames';

export const administrationRoutes = (t: (key: string) => string): RouteDefinition[] => [
  {
    path: '/user-administration/report-types/:reportTypeFrequencyId?/:reportTypePeriodId?',
    name: RouteName.ReportTypes,
    props: true,
    component: () => import('../../views/administration/ReportTypes.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Report_Type_Review],
      title: t('registry.reportTypes')
    }
  },
  {
    path: '/user-administration/statistics/report-type-periods',
    name: RouteName.ReportTypePeriodStatistics,
    props: true,
    component: () => import('../../views/administration/ReportTypePeriodStatistics.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Report_Review_All, UserClaim.Claim_Report_Economy_Review_All],
      title: t('sidebar.administrativeStatistics')
    }
  },
  {
    path: '/user-administration/statistics/organizations-statistics/:reportTypePeriodId',
    name: RouteName.OrganizationStatistics,
    props: true,
    component: () => import('../../views/administration/OrganizationStatistics.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Report_Review_All, UserClaim.Claim_Report_Economy_Review_All],
      sidebarValue: 'side-bar-administration',
      title: t('statistics.organizationStatistics')
    }
  },
  {
    path: '/user-administration/user/:userId',
    name: RouteName.UserInfo,
    component: () => import('../../views/administration/UserInfo.vue'),
    meta: {
      requiresAuth: true,
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_User_Create,
        UserClaim.Claim_User_Review,
        UserClaim.Claim_Local_User_Create,
        UserClaim.Claim_Local_User_Review
      ],
      sidebarValue: 'side-bar-administration',
      title: t('userAdministration.userDetails')
    }
  },
  {
    path: '/user-administration/registration/approval/:userId',
    name: RouteName.UserApproval,
    component: () => import('../../views/administration/UserApproval.vue'),
    meta: {
      requiresAuth: true,
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_User_Create,
        UserClaim.Claim_User_Review,
        UserClaim.Claim_Local_User_Create,
        UserClaim.Claim_Local_User_Review
      ],
      sidebarValue: 'side-bar-administration',
      title: t('userAdministration.userApproval')
    }
  },
  {
    path: '/user-administration/user-management',
    name: RouteName.UserManagement,
    component: () => import('../../views/administration/UserManagement.vue'),
    meta: {
      requiresAuth: true,
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_User_Create,
        UserClaim.Claim_User_Review,
        UserClaim.Claim_Local_User_Create,
        UserClaim.Claim_Local_User_Review
      ],
      title: t('userAdministration.administration')
    }
  },
  {
    path: '/user-administration/create-user/:formType',
    name: RouteName.CreateUser,
    component: () => import('../../views/administration/CreateUser.vue'),
    meta: {
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_User_Create,
        UserClaim.Claim_Local_User_Create
      ],
      requiresAuth: true,
      sidebarValue: 'side-bar-administration',
      title: t('userAdministration.createUser')
    }
  },
  {
    path: '/user-administration/user-notification',
    name: RouteName.UserNotifications,
    component: () => import('../../views/administration/UserNotifications.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Notification_Create],
      title: t('userAdministration.userNotification')
    }
  },
  {
    path: '/user-administration/explicit-hierarchy',
    name: RouteName.ExplicitHierarchies,
    component: () => import('../../views/administration/ExplicitHierarchies.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Explicit_Hierarchy_Review],
      title: t('userAdministration.explicitHierarchy')
    }
  },
  {
    path: '/user-administration/user-registration',
    name: RouteName.UserRegistrations,
    component: () => import('../../views/administration/UserRegistrations.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_User_Create],
      title: t('sidebar.userRegistration')
    }
  },
  {
    path: 'user-administration/registration-change',
    name: RouteName.UserRegistrationChange,
    component: () => import('../../views/administration/UserRegistration.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Registration_Edit],
      title: t('userAdministration.registrationChange')
    }
  }
];
